import { useTranslation } from 'react-i18next'
import { VpButton, VpFormControl, VpFormLabel } from '@vtmn-play/react'
import Modal from 'components/common/mygame/modal/modal'
import { Select } from 'antd'
import { useApiGetStores } from 'core/api/store/useApiGetStores'
import type { Store } from 'components/common/filters/select-store'
import { useState } from 'react'

interface SelectReferenceStoreModalProps {
  onClose: () => void
  onConfirm: (storeId: number) => void
}

const isOpenForYear = (store: Store, year: number) => {
  return store.is_open === true && store.opening_date instanceof Date && store.opening_date.getFullYear() < year
}

const SelectReferenceStoreModal = ({ onClose, onConfirm }: SelectReferenceStoreModalProps) => {
  const { t } = useTranslation()
  const [storeId, setStoreId] = useState<number | undefined>(undefined)
  const { data: stores = [], isLoading } = useApiGetStores()

  const realizedYear = new Date().getFullYear() - 1

  const onChange = (value: number) => {
    setStoreId(value)
  }

  return (
    <div className="mg-store-trajectory-select-reference-store-modal">
      <Modal
        open
        showCloseButton
        title={t('general.trajectory.store.reference.title')}
        footer={
          <VpButton
            data-testid="store-trajectory-select-reference-store-modal-close"
            variant="primary"
            variantStyle="regular"
            size="medium"
            disabled={storeId == null || isLoading}
            onClick={() => {
              if (storeId != null) onConfirm(storeId)
            }}
          >
            {t('general.trajectory.store.reference.confirm')}
          </VpButton>
        }
        onClose={onClose}
      >
        <p className="vp-body-m">{t('general.trajectory.store.reference.notice')}</p>
        <div className="mg-store-trajectory-reference-store-form">
          <VpFormControl>
            <VpFormLabel>{t('general.trajectory.store.reference.label')}</VpFormLabel>
            <Select
              id="reference-store-select"
              showSearch={{ optionFilterProp: 'label' }}
              className="mg-store-trajectory-reference-store-form-select"
              aria-label="reference store choice"
              data-testid="reference-store-select"
              placeholder={t('general.filters.selects.stores')}
              value={storeId}
              onChange={onChange}
              disabled={isLoading}
              options={
                !isLoading
                  ? stores
                      .filter(store => isOpenForYear(store, realizedYear))
                      .map(store => ({
                        value: store.id,
                        label: `${store.id} - ${store.label}`
                      }))
                  : []
              }
              size="medium"
              getPopupContainer={triggerNode => triggerNode.closest('dialog') || triggerNode.offsetParent}
              placement={'bottomLeft'}
            />
          </VpFormControl>
        </div>
      </Modal>
    </div>
  )
}

export default SelectReferenceStoreModal
